let evolution1 = function(sketch) {
    sketch.shapes = [];
    sketch.tokenId;
    sketch.zoom = -800;

    sketch.setup = function() {
        let canvas = sketch.createCanvas(400, 400, sketch.WEBGL);  
        canvas.parent('preview1');
        sketch.tokenId = getURLParameter("tokenId") || 1;
        let numberOfShapes = sketch.floor(sketch.random(20, 31));

        for (let i = 0; i < numberOfShapes; i++) {
            sketch.randomSeed(sketch.tokenId * (i + 1)); 
            sketch.shapes.push(new sketch.Shape());
        }

        // Set initial camera position
        sketch.camera(0, 0, sketch.zoom, 0, 0, 0, 0, 1, 0);
    }

    sketch.draw = function() {
        sketch.background(0);
        // Let the orbitControl take over the camera control
        sketch.orbitControl(4, 4);

        for (let shape of sketch.shapes) {
            shape.display();
            shape.update();
        }
    }

    sketch.Shape = function() {
        this.angle = sketch.random(sketch.TWO_PI);
        this.vAngle = sketch.random(sketch.TWO_PI); 
        this.y = sketch.random(-sketch.height / 2, sketch.height / 2);
        this.r = sketch.random(100, sketch.width / 2);
        this.width = sketch.random(20, 100);
        this.height = sketch.random(20, 100);
        this.depth = sketch.random(20, 100);
        this.speed = sketch.random(0.01, 0.05);  
        this.color = sketch.color(sketch.random(255), sketch.random(255), sketch.random(255), 200);
        this.type = sketch.floor(sketch.random(5));

        this.display = function() {
            sketch.push();
            sketch.translate(this.x, this.y, this.z);
            sketch.fill(this.color);
            sketch.noStroke();
            if (this.type === 0) {
                sketch.box(this.width, this.height, this.depth);
            } else if (this.type === 1) {
                sketch.sphere(this.width / 2);
            } else if (this.type === 2) {
                sketch.cone(this.width / 2, this.height);
            } else if (this.type === 3) {
                sketch.cylinder(this.width / 2, this.height);
            } else if (this.type === 4) {
                sketch.torus(this.width / 2, this.width / 4);
            }
            sketch.pop();
        }

        this.update = function() {
            this.angle += this.speed;
            this.vAngle += this.speed;
            this.x = this.r * sketch.cos(this.angle);
            this.y = this.r * sketch.sin(this.vAngle); 
            this.z = this.r * sketch.sin(this.angle);
        }
    }

    sketch.mouseWheel = function(event) {
        sketch.zoom += event.delta;
    }

    function getURLParameter(name) {
        const regex = new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)');
        const result = regex.exec(window.location.search);

        if (result) {
            return decodeURIComponent(result[1].replace(/\+/g, '%20'));
        } else {
            return null;
        }
    }
}

let myp51 = new p5(evolution1, 'preview1');





